import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import type { LocationState } from 'redux-first-router';
import { preFetchCompany as preFetchCompanyRoutine } from '@/pages/CompanyReport/redux/routines';
import { ROUTE_COMMUNITY_IDEA } from '@/constants/routes';
import { getPath } from '@/router/utils';

interface Response {
  id: string;
  canonicalUrl: string;
  preFetchCompany: (id: string) => void;
}

interface Location {
  id: string;
  canonicalUrl: string;
}

export function useReduxStateForCommunityIdeas(): Response {
  const dispatch = useDispatch();
  const { canonicalUrl, id } = useSelector<
    {
      location: LocationState;
    },
    Location
  >((state) => {
    const { id, name } = state.location.payload;
    const canonicalUrl = getPath({
      payload: {
        id,
        name,
      },
      type: ROUTE_COMMUNITY_IDEA,
    });
    return {
      id,
      canonicalUrl,
    };
  }, shallowEqual);

  const preFetchCompany = useCallback(
    (companyId: string) => {
      dispatch(preFetchCompanyRoutine.trigger({ id: companyId }));
    },
    [dispatch]
  );

  return {
    id,
    canonicalUrl,
    preFetchCompany,
  };
}
